import React from 'react';
import { AppleIcon, GooglePlayIcon } from '../StoreIcons';
import { PhoneFrame } from '../PhoneMockups';
import qrCodeImage from '../../assets/images/qrcode.svg';

const APP_STORE_URL = 'https://apps.apple.com/in/app/tarana-music/id6740995739';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.tarana.taranaMusicApp&pcampaignid=web_share';

export function Download() {
  return (
    <div className="dl-hero">
      <div className="dl-hero-bg" />
      <div className="dl-hero-overlay" />
      <div className="dl-inner">
        <div>
          <p className="s-eyebrow">Download the app</p>
          <h1 className="hero-h1" style={{ fontSize: 'clamp(44px,5.5vw,76px)', marginBottom: 20 }}>Tarana is in<br />your pocket.</h1>
          <p className="hero-sub" style={{ marginBottom: 0 }}>Create your profile, connect with the music industry, discover and hire talent, and start building your career — on iOS and Android.</p>

          <div className="dl-store-btns">
            <a href={APP_STORE_URL} className="dl-store-btn" target="_blank" rel="noopener noreferrer">
              <AppleIcon />
              <div className="dl-store-btn-text">
                <span className="dl-store-btn-sub">Download on the</span>
                <span className="dl-store-btn-name">App Store</span>
              </div>
            </a>
            <a href={PLAY_STORE_URL} className="dl-store-btn" target="_blank" rel="noopener noreferrer">
              <GooglePlayIcon className="dl-store-play-icon" />
              <div className="dl-store-btn-text">
                <span className="dl-store-btn-sub">Get it on</span>
                <span className="dl-store-btn-name">Google Play</span>
              </div>
            </a>
          </div>

          <div className="dl-qr-row">
            <div className="dl-qr-box"><img src={qrCodeImage} alt="Tarana QR code" className="dl-qr-img" /></div>
            <div className="dl-qr-text"><strong>Scan to download</strong>Point your camera at the QR code to open Tarana on your phone.</div>
          </div>

          <div className="dl-features" style={{ marginTop: 32 }}>
            <div className="dl-feat"><div className="dl-feat-dot" />Free to get started</div>
            <div className="dl-feat"><div className="dl-feat-dot" />iOS &amp; Android</div>
            <div className="dl-feat"><div className="dl-feat-dot" />Secure payments</div>
            <div className="dl-feat"><div className="dl-feat-dot" />Verified credits</div>
          </div>
        </div>

        <div className="dl-phones">
          <PhoneFrame screen="feed" frameWidth={200} screenQuery="hideStories=1" />
          <PhoneFrame screen="hire" frameWidth={248} />
          <PhoneFrame screen="profile" frameWidth={200} />
          <div className="dl-phones-glow" />
        </div>
      </div>
    </div>
  );
}
